module.exports = __webpack_public_path__ + "static/acreateaccount-e6418066c322d84941ac511f4403d9b3.png";